<template>
    <div class="complete">
        <input-cell title="姓名" :initialValue="name" @onInput="onNameInput"></input-cell>
        <input-cell title="性别" :initialValue="gender" :isInputable="false" inputType="tel"
            @onCellClick="onGenderCellClick"></input-cell>
        <input-cell title="生日" :initialValue="birthdayText" :isInputable="false" inputType="tel"
            @onCellClick="onBirthdayCellClick"></input-cell>
        <input-cell title="身高cm" :initialValue="height" inputType="number" @onInput="onHeightInput"></input-cell>
        <input-cell title="体重kg" :initialValue="weight" inputType="number" @onInput="onWeightInput"></input-cell>
        <round-button class="complete-button" color="red" title="下一步" @onClick="onNextClick"></round-button>
        <van-popup v-model="showPicker" round position="bottom">
            <van-picker title="选择性别" show-toolbar :columns="genderArray" :default-index="genderSelectedIndex"
                @confirm="onGenderPicked" @cancel="showPicker = false" />
        </van-popup>
        <van-popup v-model="showBirthdayPicker" round position="bottom">
            <van-datetime-picker title="选择生日" show-toolbar v-model="currentDate" type="date" :min-date="this.minDate"
                :max-date="this.maxDate" @confirm="onBirthdayPicked" @change="onBirthdayChange"
                @cancel="showBirthdayPicker = false" />
        </van-popup>
    </div>
</template>

<script>
import InputCell from '@c/common/input-cell.vue'
import RoundButton from '@c/common/round-button.vue'
import { NavigationTool } from '@/utils/navigation-tool.js'
import { AccountInfoModel } from '@model/account-info-model'
import dayjs from 'dayjs'


export default {
    components: {
        InputCell,
        RoundButton
    },

    data() {
        return {
            showPicker: false,
            showBirthdayPicker: false,
            number: '',
            name: '',
            currentDate: new Date(2000, 0, 1),
            birthday: undefined,
            height: '',
            weight: '',
            gender: '',
            genderArray: ['男', '女'],
            minDate: new Date(1900, 0, 1),
            maxDate: new Date(),
            frontPhoto: '',
            leftPhoto: '',
            rightPhoto: '',
            currentIndex: 0,
        }
    },

    created() {
        if (this.accountModel) {
            this.number = this.accountModel.userInfo?.mzh
            this.name = this.accountModel.userInfo?.truename
            this.birthday = this.accountModel.userInfo?.birthday ? dayjs(this.accountModel.userInfo.birthday).toDate() : undefined
            this.height = this.accountModel.userInfo?.height
            this.weight = this.accountModel.userInfo?.weight
            this.gender = this.accountModel.userInfo?.sex;
        }
    },

    computed: {
        accountModel() {
            return this.$store.state.accountModel
        },

        genderSelectedIndex() {
            return this.genderArray.indexOf(this.gender)
        },
        birthdayText() {
            return this.birthday ? dayjs(this.birthday).format('YYYY-MM-DD') : ''
        },
    },

    methods: {
        onNumberInput(value) {
            this.number = value
        },
        onNameInput(value) {
            this.name = value
        },
        onHeightInput(value) {
            this.height = value
        },
        onWeightInput(value) {
            this.weight = value
        },
        onGenderCellClick() {
            this.showPicker = true
        },
        onGenderPicked(value, index) {
            this.showPicker = false
            this.gender = value
        },
        onBirthdayCellClick() {
            this.showBirthdayPicker = true
        },
        onBirthdayPicked(value) {
            this.showBirthdayPicker = false
            this.birthday = value
        },
        onBirthdayChange(value) {
            this.birthday = this.currentDate
        },
        onNextClick() {
            if (!this.name) { return this.$toast('姓名不能为空') }
            if (!this.gender) { return this.$toast('性别不能为空') }
            if (!this.birthday) { return this.$toast('生日不能为空') }
            if (!this.height) { return this.$toast('身高不能为空') }
            if (!this.weight) { return this.$toast('体重不能为空') }
            if (isNaN(this.height) || this.height <= 0) {
                this.$toast('身高必须为正数')
                return
            }
            if (isNaN(this.weight) || this.weight <= 0) {
                this.$toast('体重必须为正数')
                return
            }

            // 用户信息存本地
            let newAccountModel
            if (this.accountModel) {
                newAccountModel = this.accountModel
                newAccountModel.userInfo.truename = this.name
                newAccountModel.userInfo.birthday = this.birthdayText
                newAccountModel.userInfo.sex = this.gender
                newAccountModel.userInfo.height = this.height
                newAccountModel.userInfo.weight = this.weight
                newAccountModel.userInfo.mzh = this.number
                newAccountModel.userInfo.frontPhoto = this.frontPhoto
                newAccountModel.userInfo.leftPhoto = this.leftPhoto
                newAccountModel.userInfo.rightPhoto = this.rightPhoto
            } else {
                // 模拟接口获取的
                const userInfoModel = {
                    userInfo: {
                        truename: this.name,
                        birthday: this.birthdayText,
                        sex: this.gender,
                        height: this.height,
                        weight: this.weight,
                        mzh: this.number,
                        frontPhoto: this.frontPhoto,
                        leftPhoto: this.leftPhoto,
                        rightPhoto: this.rightPhoto
                    }
                }
                const mobile = ''
                newAccountModel = new AccountInfoModel(userInfoModel, mobile)
            }
            this.$store.commit('saveAccountModel', newAccountModel)

            // 页面跳转
            NavigationTool.completeNavigate()
        },
        onClickDelete(index) {
            switch (index) {
                case 0:
                    this.frontPhoto = ''
                    break
                case 1:
                    this.leftPhoto = ''
                    break
                case 2:
                    this.rightPhoto = ''
                    break
            }
        },
        onClickAdd(index) {
            this.currentIndex = index
        },
        async onTakePhotoFinish(e) {
            try {
                const dataUrl = e.detail

                const fileName = new Date().getTime() + '.png'
                const blob = dataURItoBlob(dataUrl);
                const formData = new FormData();
                formData.append("file", blob, fileName);

                const [error, data] = await to(this.$axios({
                    url: URI.uploadFile,
                    method: 'post',
                    data: formData,
                    headers: { 'Content-Type': 'multipart/form-data' },
                    timeout: 1800000
                }))
                if (this.currentIndex === 0) {
                    this.frontPhoto = data
                } else if (this.currentIndex === 1) {
                    this.leftPhoto = data
                } else if (this.currentIndex === 2) {
                    this.rightPhoto = data
                }
            } catch (error) {
                console.log(error);

                this.$toast('上传失败')
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";

.complete {
    position: relative;
    background-color: #f9f9f9;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-photo-container {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 13px;
        width: 100%;
        height: 127px;
    }

    &-button {
        width: 343px;
        margin-top: 35px;
    }
}
</style>
